function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M379.6,229.2c14-14,20.8-32,20.8-50.4c0-4.8-0.4-9.6-1.6-14.4L350,213.2L314,194l-19.2-36l48.8-48.8 c-4.8-1.2-9.6-1.6-14.4-1.6c-18.4,0-36.4,6.8-50.4,20.8c-20.8,20.8-26,51.2-15.6,76.8l-138.8,114c-20.8,17.2-22.4,48.8-3.2,68l0,0 c19.2,19.2,50.8,17.6,68-3.2l114-138.8c8.4,3.2,17.6,5.2,26.4,5.2C347.6,250,365.6,243.2,379.6,229.2z M136.4,371.6 c-8.8-8.8-8.8-23.2,0-32s23.2-8.8,32,0s8.8,23.2,0,32C159.6,380.4,145.2,380.4,136.4,371.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "136,105.2 117.6,101.6 101.6,117.6 105.2,136 141.6,153.2 248.8,260.8 260.8,248.8  153.2,141.6 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M402.8,358L358,402.8c-4.4,4.4-12,4.4-16.4,0L224.4,285.6c-4.4-4.4-4.4-12,0-16.4l44.8-44.8 c4.4-4.4,12-4.4,16.4,0l117.2,117.2C407.2,346,407.2,353.6,402.8,358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M285.6,224.4l117.2,117.2c4.4,4.4,4.4,11.6,0,16.4L358,402.8c-4.4,4.4-11.6,4.4-16.4,0L224.4,285.6 c-4.4-4.4-4.4-11.6,0-16.4l44.8-44.8C274,220,281.2,220,285.6,224.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C0EB"
    },
    d: "M376.8,356.4L376.8,356.4c-3.2,3.2-8.4,3.2-11.6,0l-94-94c-3.2-3.2-3.2-8.4,0-11.6l0,0 c3.2-3.2,8.4-3.2,11.6,0l94,94C380,347.6,380,353.2,376.8,356.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C0EB"
    },
    d: "M397.2,336c-3.2,3.2-8.4,3.2-11.6,0l-94-94c-3.2-3.2-3.2-8.4,0-11.6L397.2,336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C0EB"
    },
    d: "M356.4,376.8L356.4,376.8c-3.2,3.2-8.4,3.2-11.6,0l-94-94c-3.2-3.2-3.2-8.4,0-11.6l0,0 c3.2-3.2,8.4-3.2,11.6,0l94,94C359.6,368,359.6,373.6,356.4,376.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C0EB"
    },
    d: "M242,291.6l94,94c3.2,3.2,3.2,8.4,0,11.6L230.4,291.6c1.6-1.6,3.6-2.4,6-2.4 C238.4,289.2,240.4,290,242,291.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsGear);
export default __webpack_public_path__ + "static/media/settings-gear.29aa773c53471d3b1caa7774195407cd.svg";
export { ForwardRef as ReactComponent };